export const getFilteredAirports = (data) => {
  return [...data.data].reduce((result, item) => {
    if (item.type === 'country' || item.type === 'railway' || !item.working) {
      return result;
    }
    return [...result, item];
  }, []);
};
